/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { DisciplineField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedDisciplineModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related discipline"
    subtitle="Find a discipline related to this article"
    okText="ADD DISCIPLINE"
    onSubmit={({ discipline }) => onSubmit(discipline)}
  >
    <DisciplineField
      label="Choose a discipline"
      name="discipline"
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Discipline is required' }]}
    />
  </RelatedContentModal>
);

const Item = (discipline) => <InfoItem image={discipline.image}>{discipline.name}</InfoItem>;

RelatedDisciplineModal.Item = Item;

export default RelatedDisciplineModal;
